export const CARE_TEAM = 'care_team';
